import gql from 'graphql-tag';

const FREE_DEVICE_HISTORY = gql`
  mutation FreeDeviceHistory($freeDeviceHistoryId: ID!, $situationId: ID!) {
    freeDeviceHistory(id: $freeDeviceHistoryId, situationId: $situationId) {
      succeded
      situation {
        situationId
        deviceHistoriesCount
        highPriorityEventId
        highPriorityEventCode
        highPriorityEventTechnicalDescription
        highPriorityEventColor
        highPriorityEventPriority
        highPriorityEventGroupId
        highPriorityEventGroupName
        highPriorityEventReceivedAt
        highPriorityEventGeneratedAt
        deviceId
        deviceName
        deviceUniqueId
        deviceWorkspacePrefixPrefix
      }
    }
  }
`;

const OPEN_SITUATION = gql`
  mutation OpenSituation($openSituationId: ID!, $userId: ID!) {
    openSituation(id: $openSituationId, userId: $userId) {
      id
      assignedTo
      isSelfProcessed
      generatedAt
      receivedAt
      log
    }
  }
`;

const PROCESS_SITUATION = gql`
  mutation ProcessedSituation(
    $processedSituationId: ID!
    $situationCategoryId: ID!
    $comment: String!
  ) {
    processedSituation(
      id: $processedSituationId
      situationCategoryId: $situationCategoryId
      comment: $comment
    ) {
      receivedAt
      id
      generatedAt
      log
    }
  }
`;

const PROCESS_SITUATIONS = gql`
  mutation ProcessedSituations(
    $ids: [ID!]!
    $situationCategoryId: ID!
    $comment: String!
  ) {
    processedSituations(
      ids: $ids
      situationCategoryId: $situationCategoryId
      comment: $comment
    ) {
      successCount
      failedCount
      failedIds
    }
  }
`;

const COMMENT_SITUATION = gql`
  mutation CommentSituation(
    $commentSituationId: ID!
    $userId: ID!
    $comment: String!
    $phoneContact: PhoneContactInput
  ) {
    commentSituation(
      id: $commentSituationId
      userId: $userId
      comment: $comment
      phoneContact: $phoneContact
    ) {
      log
      id
      generatedAt
      receivedAt
    }
  }
`;

const UPDATE_MONITORING_STATUS = gql`
  mutation UpdateStatusMonitoring($data: updateStatusMonitoringInput!) {
    updateStatusMonitoring(data: $data) {
      workspaceId
      userId
      status
    }
  }
`;

const OPEN_SITUATION_CHAT = gql`
  mutation OpenConversation($situationId: ID!, $userId: ID!) {
    openConversation(situationId: $situationId, userId: $userId) {
      id
      assignedTo
      isSelfProcessed
      generatedAt
      receivedAt
      log
    }
  }
`;

const OPEN_CALL_WINDOW = gql`
  mutation OpenCallWindow(
    $situationId: ID!
    $userId: ID!
    $phoneContact: PhoneContactInput!
  ) {
    openCallWindow(
      situationId: $situationId
      userId: $userId
      phoneContact: $phoneContact
    ) {
      id
      assignedTo
      isSelfProcessed
      generatedAt
      receivedAt
      log
    }
  }
`;

const START_CALL_RECORDING = gql`
  mutation StartCallRecording(
    $situationId: ID!
    $callId: ID!
    $direction: String!
    $calledNumber: String
    $extension: String
    $userId: ID!
  ) {
    startCallRecording(
      situationId: $situationId
      callId: $callId
      direction: $direction
      calledNumber: $calledNumber
      extension: $extension
      userId: $userId
    ) {
      id
      log
    }
  }
`;

const ADD_CALL_CHUNK = gql`
  mutation AddCallChunk(
    $situationId: ID!
    $callId: ID!
    $chunkKey: String!
    $chunkIndex: Int!
  ) {
    addCallChunk(
      situationId: $situationId
      callId: $callId
      chunkKey: $chunkKey
      chunkIndex: $chunkIndex
    ) {
      id
      log
    }
  }
`;

const FINALIZE_CALL_RECORDING = gql`
  mutation FinalizeCallRecording(
    $situationId: ID!
    $callId: ID!
    $totalDuration: Int!
  ) {
    finalizeCallRecording(
      situationId: $situationId
      callId: $callId
      totalDuration: $totalDuration
    ) {
      id
      log
    }
  }
`;

const OPEN_CCTV_CAMERA = gql`
  mutation OpenCctvCamera(
    $situationId: ID!
    $userId: ID!
    $channelId: ID!
    $channelName: String!
  ) {
    openCctvCamera(
      situationId: $situationId
      userId: $userId
      channelId: $channelId
      channelName: $channelName
    ) {
      id
      log
      generatedAt
      receivedAt
    }
  }
`;

const HOLD_SITUATION = gql`
  mutation HoldSituation($holdSituationId: ID!, $userId: ID!) {
    holdSituation(id: $holdSituationId, userId: $userId) {
      id
      log
    }
  }
`;

const CHECK_CCTV_CHANNEL_ROUND = gql`
  mutation checkCCTVChannelRound(
    $situationId: ID!
    $userId: ID!
    $channelId: ID!
    $channelName: String!
    $comment: String!
  ) {
    checkCCTVChannelRound(
      situationId: $situationId
      userId: $userId
      channelId: $channelId
      channelName: $channelName
      comment: $comment
    ) {
      id
      log
      generatedAt
      receivedAt
    }
  }
`;

const GENERATE_CALL_SUMMARY = gql`
  mutation GenerateCallSummary($situationId: ID!, $callId: ID!) {
    generateCallSummary(situationId: $situationId, callId: $callId) {
      summary
    }
  }
`;

export default {
  FREE_DEVICE_HISTORY,
  OPEN_SITUATION,
  PROCESS_SITUATION,
  PROCESS_SITUATIONS,
  COMMENT_SITUATION,
  UPDATE_MONITORING_STATUS,
  OPEN_SITUATION_CHAT,
  OPEN_CALL_WINDOW,
  START_CALL_RECORDING,
  ADD_CALL_CHUNK,
  FINALIZE_CALL_RECORDING,
  OPEN_CCTV_CAMERA,
  CHECK_CCTV_CHANNEL_ROUND,
  HOLD_SITUATION,
  GENERATE_CALL_SUMMARY,
};
